module.exports = __webpack_public_path__ + "img/download.5153dc2b.svg";